import gql from 'graphql-tag'
import { EnumFields } from '..'

// TODO: include [icon, color] when available
export const AccountTypeFragment = gql`
  fragment AccountType on persons_account_type {
    ${EnumFields}
  }
`
